// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.securearea

import org.multipaz.cbor.DataItem
import org.multipaz.securearea.KeyAttestation
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.crypto.PublicKey
import org.multipaz.crypto.X509CertChain

fun KeyAttestation.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "PIwOWWhzGfimysywpuT09shxd4Z-cskOlvsBoIsRMq0")
val KeyAttestation_cborSchemaId = ByteString(60, -116, 14, 89, 104, 115, 25, -8, -90, -54, -52, -80, -90, -28, -12, -10, -56, 113, 119, -122, 126, 114, -55, 14, -106, -5, 1, -96, -117, 17, 50, -83)

fun KeyAttestation.Companion.fromCbor(data: ByteArray): KeyAttestation {
    return KeyAttestation.fromDataItem(Cbor.decode(data))
}

val KeyAttestation.Companion.cborSchemaId: ByteString
    get() = KeyAttestation_cborSchemaId

fun KeyAttestation.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("publicKey", this.publicKey.toDataItem())
    val certChain = this.certChain
    if (certChain != null) {
        builder.put("certChain", certChain.toDataItem())
    }
    return builder.end().build()
}

fun KeyAttestation.Companion.fromDataItem(dataItem: DataItem): KeyAttestation {
    val publicKey = PublicKey.fromDataItem(dataItem["publicKey"])
    val certChain0 = if (dataItem.hasKey("certChain")) {
        X509CertChain.fromDataItem(dataItem["certChain"])
    } else {
        null
    }
    return KeyAttestation(
        publicKey = publicKey,
        certChain = certChain0,
    )
}
